<script>
import { mixins, Pie } from "vue-chartjs";
import "chart.js-plugin-labels-dv";
import AnalysisTooltip from "./analysis_tooltip.js";

const { reactiveProp } = mixins;

export default {
	name: "donut-chart",
	extends: Pie,
	mixins: [reactiveProp],
	props: {
		chartData: Object,
		chartOptions: Object,
	},
	data() {
		return {
			calculatedChartOptions() {
				// @ts-expect-error
				let chartOptions = this.chartOptions;
				chartOptions.plugins.tooltip = AnalysisTooltip;

				chartOptions.animation = {
					x: {
						from: (context) => {
							return context.chart.canvas.width / 2;
						},
					},
					y: {
						from: (context) => {
							return (
								((context.chart.legend.position == "top"
									? context.chart.legend.height
									: 0) +
									context.chart.canvas.height) /
								2
							);
						},
					},
				};
				return chartOptions;
			},
		};
	},
	// beforeCreate() {
	// 	pp.log("Donut chart before create:", this);
	// },
	mounted() {
		// pp.log("CHART DATA INITIAL", this.chartData.labels, this.chartData.datasets[0]);
		const chartDataArray = this.chartData
			? // @ts-expect-error
				this.chartData.datasets[0].data
			: [];

		if (
			// @ts-expect-error
			this.chartData.datasets[0].backgroundColor === undefined &&
			// @ts-expect-error
			this.chartData.datasets[0].colorClasses
		) {
			// @ts-expect-error
			this.chartData.datasets[0].backgroundColor =
				// @ts-expect-error
				this.chartData.datasets[0].colorClasses.map((colorClass) => {
					return pp.viewHelpers.detectCssRuleFor(
						colorClass,
						"background-color",
					);
				});
		}
		if (this.chartData && this.chartDataSum(chartDataArray) > 0) {
			// @ts-expect-error
			this.renderChart(this.chartData, this.calculatedChartOptions());
		} else {
			console.error("Chart data incompatible with pie chart", chartDataArray);
		}
	},
	methods: {
		chartDataSum(dataArray) {
			// pp.log("chartDataSum", dataArray);
			return dataArray.reduce((a, b) => a + b, 0);
		},
	},
	watch: {
		chartData: function () {
			// @ts-expect-error
			this._data._chart.data.datasets[0].data = this.chartData.datasets[0].data;
			// @ts-expect-error
			this._data._chart.update();
		},
	},
};
</script>
